<template>
  <section class="our-word px-5 lg:px-32 mt-[15rem]">

    <div class="hero-content">
      <h1 class="hero-title">
        <span class="text-line">Don't just take</span>
        <span class="text-line"><span class="gradient-text">our word </span> for it.</span>
      </h1>
      <p class="hero-subtitle xl:whitespace-nowrap">
        Hear what our clients have to say about working with us.
      </p>
    </div>

    <div class="lg:hidden testimonial-cards mt-[80px]">
      <div
        v-for="(testimonial, index) in testimonials"
        :key="index"
        class="testimonial-card relative rounded-[8px] bg-white mt-4"
      >
        <div class="text-block bg-[#161816] rounded-t-[8px]">
          <p class="testimonial-text"><span>{{ testimonial.text }}</span></p>
        </div>
        <div class="flex items-center w-full justify-end bg-[#161816] p-4">
          <p class="testimonial-name mt-[23px] font-[300]">{{ testimonial.name }} {{ testimonial.title }}</p>
        </div>
        <div class="w-full px-[13px] h-[63px] rounded-b-[8px]">
          <div class="w-full flex items-center justify-end h-full">
            <img width="74px" height="46px" :src="testimonial.img" alt="">
          </div>
        </div>
        <div class="absolute bottom-5 left-5 bg-[#FF00EA] w-[94px] h-[94px] rounded-full">
          <img class="w-[94px] h-[94px] rounded-full" :src="testimonial.avatar" alt="avatar">
        </div>
      </div>
    </div>
    <div class="hidden lg:grid lg:grid-cols-2 testimonial-cards lg:gap-[24px] mt-[80px]">
      <div class="grid gap-[24px]">
        <div
          v-for="(testimonial, index) in testimonials.slice(0, 6)"
          :key="index"
          :class="['testimonial-card-desktop', 'hover:bg-[#52DA75]', 'flex', 'relative', 'rounded-[8px]', 'bg-[#161816]', 'h-auto']"
        >
          <div class="w-[133px] px-[13px] py-[41px] h-full rounded-b-[8px]">
            <div class="w-full flex items-end h-full">
              <img width="74px" height="46px" :src="testimonial.img" alt="">
            </div>
          </div>
          <div class="absolute top-5 left-5 bg-[#FF00EA] w-[133px] h-[133px] rounded-full">
            <img class="rounded-full w-[133px] h-[133px]" :src="testimonial.avatar" alt="avatar">
          </div>
          <div class="w-full">
            <div class="text-block-desktop bg-[#161816] w-full h-full mb-0.5 rounded-r-[8px]">
              <p class="testimonial-text-desktop"><span>{{ testimonial.text }}</span></p>
              <div class="flex items-center w-full justify-start bg-[#161816]">
                <p class="testimonial-name-desktop mt-[23px] font-[300]">{{ testimonial.name }} <br> {{ testimonial.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid gap-[24px]">
        <div
          v-for="(testimonial, index) in testimonials.slice(6)"
          :key="index"
          :class="['testimonial-card-desktop', 'hover:bg-[#52DA75]', 'flex', 'relative', 'rounded-[8px]', 'bg-[#161816]', 'h-auto']"
        >
          <div class="w-[133px] px-[13px] py-[41px] h-full rounded-b-[8px]">
            <div class="w-full flex items-end h-full">
              <img width="74px" height="46px" :src="testimonial.img" alt="">
            </div>
          </div>
          <div class="absolute top-5 left-5 bg-[#FF00EA] w-[133px] h-[133px] rounded-full">
            <img class="rounded-full w-[133px] h-[133px]" :src="testimonial.avatar" alt="avatar">
          </div>
          <div class="w-full">
            <div class="text-block-desktop bg-[#161816] w-full h-full mb-0.5 rounded-r-[8px]">
              <p class="testimonial-text-desktop"><span>{{ testimonial.text }}</span></p>
              <div class="flex items-center w-full justify-start bg-[#161816]">
                <p class="testimonial-name-desktop mt-[23px] font-[300]">{{ testimonial.name }} <br> {{ testimonial.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button ref="buttonRef" class="cta-button mt-[4rem] lg:mt-[4rem]" style="z-index: 120; !important" @click="goToContactUs">
        <span class="text text-[12px] lg:text-[24px]">Book a call</span>
        <svg class="arrow hidden lg:block" fill="none" height="19" viewBox="0 0 35 19" width="35" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 9.27539H33.0682" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          <path d="M25.8932 1L32.2859 7.39262C33.328 8.4347 33.328 10.1277 32.2859 11.1698L25.8932 17.5624" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </svg>
        <svg class="lg:hidden" fill="none" height="14" viewBox="0 0 25 14" width="25" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 7.27686H24" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.854 1.3418L23.4389 5.92672C24.1863 6.67413 24.1863 7.8884 23.4389 8.63581L18.854 13.2207" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </section>
</template>
<script lang="ts" setup>
import { onMounted } from 'vue';
import { gsap } from 'gsap';
import { TextPlugin } from 'gsap/TextPlugin';
import numan from "../assets/testimonials/img.png"
import zoe from "../assets/testimonials/img_1.png"
import kitkat from "../assets/testimonials/img_2.png"
import fyxer from "../assets/testimonials/img_3.png"
import neat from "../assets/testimonials/img_4.png"
import pinpoint from "../assets/testimonials/img_5.png"
import sipgood from "../assets/testimonials/img_6.png"
import {useRouter} from "vue-router";
import stanley from "../assets/avatars/img.png"
import Ellen from "../assets/avatars/img_1.png"
import calum from "../assets/avatars/img_2.png"
import runna from "../assets/runna/img_10.png"
import yonder from "../assets/yonder/img_10.png"
import ebuyer from "../assets/ebuyer/img_1.png"
import life from "../assets/life/img.png"
import monica from "../assets/monica/img_3.png"
import raphael from "../assets/avatars/img_3.png"
import lonneke from "../assets/avatars/img_4.png"
import sian from "../assets/avatars/img_6.png"
import aditi from "../assets/avatars/img_5.png"
import micah from "../assets/avatars/img_7.png"
import jenni from "../assets/avatars/img_8.png"
import sophie from "../assets/avatars/img_9.png"
import fiona from "../assets/avatars/img_10.png"
import sunday from "../assets/sundayCitizen/img.png"

gsap.registerPlugin(TextPlugin);
const router = useRouter()

onMounted(() => {
  const tl = gsap.timeline({
    defaults: { ease: "power3.out" }
  });

  // Animate text lines
  tl.from(".text-line", {
    y: 100,
    opacity: 0,
    duration: 1,
    stagger: 0.3,
  });

  // Animate subtitle
  tl.from(".hero-subtitle", {
    y: 30,
    opacity: 0,
    duration: 1,
  }, "-=0.5");

  // Gradient shine effect
  gsap.to(".gradient-text", {
    backgroundPosition: "300% center",
    duration: 4,
    repeat: -1,
    ease: "none"
  });
});

const goToContactUs = () => {
  window.open("https://app.usemotion.com/meet/toby-green-bbrz/catalyst?d=30", "_blank");
};

const testimonials = [
  {
    img: numan,
    text: "\"Working with Tobias & Catalyst has been a transformative experience. Their expertise and innovative approach have allowed us to reevaluate and enhance our paid social account structure and performance. We've introduced more and better UGC content, allowing us to improve our engagement with our audience while expanding our reach. Overall, our performance has seen a significant improvement and his contributions has been instrumental in our growth and success\"",
    name: 'Stanley Lo,',
    title: 'Growth Performance Lead',
    avatar: stanley
  },
  {
    img: kitkat,
    text: "\"Catalyst has transformed our Meta creative testing process, significantly increasing both the volume and efficiency of UGC content and tests. They allowed us to experiment with authentic content that deeply resonates with audiences, which we were struggling to find before, and a key bonus was the streamlined creative brainstorming sessions led by Tobias that helped us generate high-quality ideas more efficiently, and look at creative from a whole new angle on a weekly cadence.\"",
    name: 'Ellen Whyte,',
    title: 'Acquisition Lead',
    avatar: Ellen
  },
  {
    img: runna,
    text: "\"Working with Catalyst has been a fantastic experience. From brainstorming and briefing, to execution and the way they handle feedback, the team have left us thoroughly impressed. All work is completed efficiently and to a high standard, showing Catalyst have a clear understanding of our brand and our goals. They really feel like an extension to our internal team!\"",
    name: 'Calum Park,',
    title: 'Creative Manager',
    avatar: calum
  },
  {
    img: sipgood,
    text: "\"Catalyst managed our performance marketing right after we launched and have done a phenomenal job getting us off the ground and scaling the account and sales. Their unique approach to creative and the flywheel approach helped us explore new angles and work with a variety of creators and creative types. Couldn't recommend highly enough!\"",
    name: 'Aditi Kibe-Heal,',
    title: 'Co-Founder',
    avatar: aditi
  },
  {
    img: ebuyer,
    text: "\"Catalyst have significantly increased our creative output on Meta, providing a wide range of engaging and innovative content deliverables that continue to revolutionise our performance on paid ads. Their team of creative strategists and high-level performance marketers help us to stay ahead of the curve and continuously scale our account.\"",
    name: 'Micah Howell,',
    title: 'Digital Marketing Exectuive',
    avatar: micah
  },
  {
    img: monica,
    text: "\"Partnering with Catalyst has truly transformed our brand. Their skill in creator content has enabled us to scale our campaigns smoothly and deliver impressive results!\"",
    name: 'Sophie Brouwer,',
    title: 'Paid Social Content Lead',
    avatar: sophie
  },
  {
    img: life,
    text: "\"Catalyst have been a valuable partner, helping us significantly ramp up the volume of paid social content (UGC) across our key international markets, including UK, Australia, and Canada.\n" +
        "\n" +
        "The team helped us scale creative production and iterate and test variations of top performing assets efficiently. They have been collaborative and responsive, bringing a strategic mindset to the creative process. Beyond content production, the deep dives from Catalyst’s performance team have been invaluable, providing detailed analysis of our Meta creative performance, and to shape a testing and iteration strategy that feeds directly into our creative brainstorming sessions. Catalyst have brought a data driven approach to our creative, with fresh thinking and actionable insights, and have proven to be a true extension of our team.\"",
    name: 'Jenni Dodd,',
    title: 'Senior Marketing Lead',
    avatar: jenni
  },
  {
    img: zoe,
    text: "\"Working with Tobias and the Catalyst Agency team was an incredible experience. They led our creative weekly sessions with precision, driving the production of new ads and ensuring a seamless feedback loop that continually improved our process and performance of our ads.\n" +
        "\n" +
        "Through their creative strategy and iteration cycles we were able to massively increase creative output and the amount of winning creatives from informed learnings.\n" +
        "\n" +
        "Thanks to Tobias and the Catalyst team, we were able to scale our account to new heights. It was truly a fantastic experience to work with them, and I highly recommend their services.\"",
    name: 'Raphael Yarish,',
    title: 'US Expansion Lead',
    avatar: raphael
  },
  {
    img: neat,
    text: "\"Working with the team at Catalyst Growth has been an absolute pleasure! Not only are they fun and easy to collaborate with, they also understand the ins and outs of the industry. They really take the time to dive deep into what’s working and what’s not, especially when analysing which ads are gaining traction for us on Meta. Through their creative process, they always come up with fresh, engaging ideas that may resonate with our audience. We really value their expertise and the positive energy they bring to the table!\"",
    name: 'Lonneke Spierings,',
    title: 'Head of DTC',
    avatar: lonneke
  },
  {
    img: yonder,
    text: "\"Catalyst have been a brilliant creative partner for us at Yonder. They genuinely feel like an extension of our team, easy to collaborate with, always bringing fresh ideas to the table, and never afraid to challenge our look and feel in the right ways. They've helped us level up with a more data-driven approach to creative, and unlocked content production at scale.\"",
    name: 'Sian Everill,',
    title: 'Senior Growth Marketer',
    avatar: sian
  },
  {
    img: sunday,
    text: "\"Catlayst are hands down the best creative agency you will come across, fast, fun, on point and most importantly it drives better CPA!! Highly recommend!\"",
    name: 'Fiona Grindlay-Kuzian,',
    title: 'CMO',
    avatar: fiona
  },
];
</script>
<style scoped>
.cta-button {
  background: #161816;
  color: white;
  border: 1px solid #ffffff;
  padding: 8px 16px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: fit-content;
}
.hero-title {
  padding: 5px 0;
  font-size: clamp(2.5rem, 5vw, 5rem);
  color: #ffffff;
  line-height: 30px;
  margin-bottom: 1.5rem;
  font-weight: 500;
  font-family: 'Helvetica Now Display', sans-serif;
}
.text-line {
  display: block;
  overflow: hidden;
}

.gradient-text {
  background: linear-gradient(
      90deg,
      #52e475 0%,
      #3cdff8 25%,
      #e248ce 50%,
      #3cdff8 75%,
      #52e475 100%
  );
  background-size: 300% auto;
  background-position: 0% center;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.hero-subtitle {
  font-size: clamp(12px, 2vw, 24px);
  color: white;
  max-width: 600px;
  line-height: 1.6;
  font-family: 'Helvetica Now Display', sans-serif;
  font-weight: 500;
}

.testimonial-card {
  border: 1px solid #fff;
}
.testimonial-card-desktop {
  border: 1px solid #fff;
  background: #fff;
  min-height: 320px;
}
.testimonial-card-desktop:hover {
  border: 1px solid #52DA75;
  box-shadow: 0px 0px 20px 0px #52DA75;
  background: #52DA75;
}

.text-block {
  padding: 20px 39px 23px 23px;
}
.text-block-desktop {
  padding: 36px 23px 42px 61px;
}

.testimonial-text {
  color: #FFF;
  font-family: "Helvetica Now Display";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
.testimonial-text-desktop {
  color: #FFF;
  font-family: "Helvetica Now Display";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

.testimonial-name {
  color: #FFF;
font-family: "Helvetica Now Display";
font-size: 12px;
font-style: normal;
font-weight: 300;
line-height: 22px;
}
.testimonial-name-desktop {
  color: #FFF;
font-family: "Helvetica Now Display";
font-size: 16px;
font-style: normal;
font-weight: 300;
line-height: 22px;
}

/* Mobile styles */
@media (max-width: 768px) {
  .hero-section {
    padding: 1rem;
    text-align: left;
    /*    background-image: url("../assets/images/img.png");
        background-size: 200px;
        background-position-x: right;
        background-position-y: top;*/
  }

  .hero-content {
    padding: 0;
  }

  .hero-title {
    font-size: 30px;
  }

  .hero-subtitle {
    font-size: 12px;
    max-width: 200px;
  }

  .background-pattern {
    top: 3rem;
    right: 0;
    height: 300px;
    width: 300px;
    opacity: 0.8;
  }
}
@media only screen and (min-width: 1024px) {
  .hero-title {
    line-height: 80px;
  }
}
</style>
